import {
  getStudioApproval,
  // getStudioMembers,
  getRolesList,
  getUserGroupsList,
  getServicePermissionsList,
  fetchGameList,
  getStudioMembersHasPermission,
} from '../../../api';
import { fetchEnvCollectionList } from '../../../api/game/env';
import {
  // IAPIStudioMemberItem,
  IStudioMemberApprovalItem,
  StudioMemberInviteStatus,
  IAPIGameItem,
  IAPIStudioMemberHasPermissionItem,
  RoleType,
} from '../../../model/api-modules';
import { IComponentProps } from '../../../model/studio';
import React, { useEffect, useRef, useState } from 'react';
import { ApplicationComponent } from './detail-table/application';
import { MemberComponent } from './detail-table/member/index';
import { RolesComponent } from './detail-table/roles';
import { GroupsComponent } from './detail-table/groups';
import './style.scss';
import { OrganizationTab, OrganizationTabs } from './tabs';
import {
  IRBACRole,
  IRBACUserGroup,
  IServicePermissions,
  WindowEvent,
} from '../../../model';
import { getLocationSearchParam } from '../../../lib';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../store/reducers';
import { wrapTimeReport } from '../../lib/bk-report';

export interface IOption {
  label: string;
  value: string;
}

export const OrganizationContentComponent = (props: IComponentProps) => {
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const [memberList, setMemberList] = useState<
    ReadonlyArray<IAPIStudioMemberHasPermissionItem>
  >([]);
  const [membersLength, setMembersLength] = useState<number>(0);
  const [ownerUserId, setOwnerUserId] = useState<string>('');

  const [tabKey, setTabKey] = useState<OrganizationTab>(
    OrganizationTab.Members
  );
  const [applicationList, setApplicationList] = useState<
    ReadonlyArray<IStudioMemberApprovalItem>
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [rolesList, setRolesList] = useState<ReadonlyArray<IRBACRole>>([]);
  const [groupsList, setGroupsList] = useState<ReadonlyArray<IRBACUserGroup>>(
    []
  );
  const [permissionsList, setPermissionsList] =
    useState<IServicePermissions | null>(null);
  const [rolesAndGroupsOptions, setRolesAndGroupsOptions] = useState<IOption[]>(
    []
  );
  const [gameList, setGameList] = useState<ReadonlyArray<IAPIGameItem>>([]);
  const [allEnvList, setAllEnvList] = useState<any>({});
  const isFirstLoad = useRef(true);

  const studioID = props.studioInfo.studio.StudioID;

  useEffect(() => {
    wrapTimeReport(initialization);
  }, []);

  useEffect(() => {
    extractOptions();
  }, [groupsList, rolesList, memberList]);

  const initialization = async () => {
    const currentKey: any =
      getLocationSearchParam('tabKey') || OrganizationTab.Members;
    if (currentKey && Object.values(OrganizationTab).includes(currentKey)) {
      await onTabKeyChange(currentKey);
    }
    queryStudioApproval();
    queryRolesList();
    queryGroupsList();
    queryPermissionsList();
    getGameAndEnv();
  };

  const permissionChangeHandler = () => {
    initialization();
  };

  useEffect(() => {
    window.addEventListener(
      WindowEvent.PermissionChange,
      permissionChangeHandler
    );

    return () => {
      window.removeEventListener(
        WindowEvent.PermissionChange,
        permissionChangeHandler
      );
    };
  }, [permissionChangeHandler]);

  const getGameAndEnv = async () => {
    setLoading(true);
    const gameRes = await fetchGameList();
    setGameList(gameRes || []);

    const envRes = await fetchEnvCollectionList(studioID);

    if (envRes && gameRes) {
      const envDataList = gameRes.map((item) => {
        const envs: any = [];
        envRes?.forEach((env) => {
          if (item.gameID === env.gameID) {
            envs.push(env);
          }
        });
        return { name: item.gameID, envs };
      });
      const envCollectionList = envDataList.reduce(
        (acc: any, { name, envs }) => {
          acc[name] = envs;
          return acc;
        },
        {}
      );
      setAllEnvList(envCollectionList);
    }
    setLoading(false);
  };

  const queryPermissionsList = async () => {
    setLoading(true);
    const res = await getServicePermissionsList();
    if (res) {
      setPermissionsList(res);
    }
    setLoading(false);
  };

  const queryRolesList = async () => {
    setLoading(true);
    const res = await getRolesList(studioID);

    if (res && res.length !== 0) {
      setRolesList(res);
    } else {
      setRolesList([]);
    }
    setLoading(false);
  };

  const queryGroupsList = async () => {
    setLoading(true);
    const res = await getUserGroupsList(studioID);
    if (res && res.length !== 0) {
      setGroupsList(res);
    } else {
      setGroupsList([]);
    }
    setLoading(false);
  };

  const updateRole = () => {
    queryRolesList();
    queryPermissionsList();
  };

  const updateGroup = () => {
    queryGroupsList();
    getGameAndEnv();
    queryStudioMember();
  };

  const extractOptions = () => {
    const isUserAdminOrOwner = memberList
      .find((member) => member.UserID === userInfo?.UserID)
      ?.RbacMember.some((role) =>
        [RoleType.Admin, RoleType.Owner].includes(role.roleType)
      );
    const rolesListAdmin = rolesList.filter((role) => role.type === 'admin');
    const rolesOptions = rolesListAdmin.map((role) => ({
      label: role.roleName,
      value: `roleGroup-${role.roleId}`, // 使用模板字符串进行拼接
    }));
    const userGroupsOptions = groupsList.map((userGroup) => ({
      label: userGroup.groupName,
      value: `userGroup-${userGroup.groupId}`, // 使用模板字符串进行拼接
    }));

    const combinedOptions = [...rolesOptions, ...userGroupsOptions];
    // console.log('combinedOptions去重111', combinedOptions);
    const uniqueOptions = Array.from(
      new Set(combinedOptions.map((option) => option.value))
    )
      .map((value) => combinedOptions.find((option) => option.value === value))
      .filter((option) => option !== undefined)
      .filter((option) => {
        if (!isUserAdminOrOwner && option?.label === 'Admin Group') {
          return false;
        }
        return true;
      }) as IOption[];

    // console.log('uniqueOptions=去重222', uniqueOptions);
    setRolesAndGroupsOptions(uniqueOptions);
  };
  const queryStudioMember = async () => {
    setLoading(true);
    // const res = await getStudioMembers(studioID);
    const res = await getStudioMembersHasPermission(studioID);
    if (res) {
      setMemberList(res);
      if (res.length > 0) {
        const newMemberList: IAPIStudioMemberHasPermissionItem[] = res.filter(
          (item) => item.UserID !== 'InGame_Support@tencent.com'
        );
        const owner = res.find((item) =>
          item.RbacMember?.some((member) => member.roleType === RoleType.Owner)
        );
        setMembersLength(newMemberList.length);
        if (owner) {
          setOwnerUserId(owner.UserID);
        }
      }
    }
    setLoading(false);
  };

  const queryStudioApproval = async () => {
    setLoading(true);
    const res = await getStudioApproval(
      studioID,
      StudioMemberInviteStatus.NotApproved
    );
    setApplicationList(res || []);
    setLoading(false);
  };

  const onReloadApplication = (isAgree: boolean) => {
    if (isAgree) {
      queryStudioMember();
      queryGroupsList();
    }
    queryStudioApproval();
  };

  const onReloadStudioMember = () => {
    // props.onReload();
    queryStudioMember();
    queryGroupsList();
  };

  const onTabKeyChange = async (key: OrganizationTab) => {
    setTabKey(key);
    if (key === OrganizationTab.Applications) {
      return queryStudioApproval();
    }
    if (key === OrganizationTab.Groups) {
      return Promise.all([getGameAndEnv(), queryGroupsList()]);
    }
    if (key === OrganizationTab.Roles) {
      return Promise.all([queryPermissionsList(), queryRolesList()]);
    }
    return queryStudioMember();
  };

  const renderComponent = () => {
    switch (tabKey) {
      case OrganizationTab.Members:
        return (
          <MemberComponent
            updateList={queryStudioMember}
            memberList={memberList}
            loading={loading}
            studioInfo={props.studioInfo}
            isOwner={props.isOwner}
            ownerUserId={ownerUserId}
            onReload={onReloadStudioMember}
            rolesList={rolesList}
            userGroupsList={groupsList}
            rolesAndGroupsOptions={rolesAndGroupsOptions}
          />
        );
      case OrganizationTab.Applications:
        return (
          <ApplicationComponent
            applicationList={applicationList}
            memberList={memberList}
            studioInfo={props.studioInfo}
            onUpdate={onReloadApplication}
            loading={loading}
            rolesAndGroupsOptions={rolesAndGroupsOptions}
            // rolesList={rolesList}
            // userGroupsList={groupsList}
          />
        );
      case OrganizationTab.Roles:
        return (
          <RolesComponent
            loading={loading}
            rolesList={rolesList}
            studioId={studioID}
            onUpdate={updateRole}
            permissionsList={permissionsList}
            groupsList={groupsList}
          />
        );
      case OrganizationTab.Groups:
        return (
          <GroupsComponent
            loading={loading}
            groupsList={groupsList}
            rolesList={rolesList}
            studioId={studioID}
            onRoleUpdate={queryRolesList}
            onUpdate={updateGroup}
            gameList={gameList}
            allEnvList={allEnvList}
            memberList={memberList}
            studioInfo={props.studioInfo}
            permissionsList={permissionsList}
            isFirstLoad={isFirstLoad}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="organizationContent">
      <OrganizationTabs
        className="organizationTabs"
        onChange={onTabKeyChange}
        tabKey={tabKey}
        membersLength={membersLength}
        applicationsLength={applicationList.length}
        rolesLength={rolesList.length}
        groupsLength={groupsList.length}
      />
      {renderComponent()}
    </div>
  );
};
